import React from 'react';
import { useNode } from '@craftjs/core';
import { Box, Typography, Slider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 10px',
    border: '2px dashed #9c27b0',
    borderRadius: 4,
    backgroundColor: 'rgba(156, 39, 176, 0.06)',
    cursor: 'move',
    userSelect: 'none',
    minWidth: 80,
  },
  label: {
    fontWeight: 600,
    color: '#9c27b0',
    lineHeight: 1.2,
  },
  binding: {
    fontSize: '0.65rem',
    color: '#ba68c8',
    fontFamily: 'monospace',
    lineHeight: 1.2,
  },
}));

function DynamicFieldSettings() {
  const { fontSize, color, actions: { setProp } } = useNode((node) => ({
    fontSize: node.data.props.fontSize,
    color:    node.data.props.color,
  }));

  return (
    <Box p={1}>
      <Typography variant="caption" display="block" gutterBottom>
        Tamaño de fuente
      </Typography>
      <Slider
        value={fontSize || 14}
        min={8}
        max={72}
        step={1}
        onChange={(_, v) => setProp((props) => { props.fontSize = v; })}
        valueLabelDisplay="auto"
      />
      <Typography variant="caption" display="block" gutterBottom style={{ marginTop: 8 }}>
        Color
      </Typography>
      <input
        type="color"
        value={color || '#333333'}
        onChange={(e) => setProp((props) => { props.color = e.target.value; })}
        style={{ width: '100%', height: 32, cursor: 'pointer', border: 'none', padding: 0 }}
      />
    </Box>
  );
}

export const DynamicField = ({ fieldKey, fieldLabel, fieldType, fontSize, color }) => {
  const { connectors: { connect, drag } } = useNode();
  const classes = useStyles();

  const iconName =
    fieldType === 'image'    ? 'image' :
    fieldType === 'date'     ? 'calendar_today' :
    fieldType === 'richtext' ? 'text_snippet' :
    fieldType === 'boolean'  ? 'toggle_on' :
    'data_object';

  return (
    <Box
      ref={(ref) => connect(drag(ref))}
      className={classes.wrapper}
      style={{ fontSize: fontSize || 14, color: color || '#333' }}
    >
      <span className="material-icons" style={{ fontSize: '1rem', color: '#9c27b0' }}>
        {iconName}
      </span>
      <Box>
        <Typography className={classes.label} style={{ fontSize: fontSize || 14 }}>
          {fieldLabel}
        </Typography>
        <Typography className={classes.binding}>{`{{${fieldKey}}}`}</Typography>
      </Box>
    </Box>
  );
};

DynamicField.craft = {
  displayName: 'Campo dinámico',
  props: {
    fieldKey:   '',
    fieldLabel: 'Campo',
    fieldType:  'text',
    fontSize:   14,
    color:      '#333',
  },
  related: {
    settings: DynamicFieldSettings,
  },
};
